import React, { useState } from "react";
import styles from "./footer.module.scss";
import { images } from "../../constants/images";

const Footer = () => {
    const [optionsSelected, setOptionSelected] = useState(4);
    const footerOptions = [
        {
            label: "FAQ",
            title: "FAQ",
            description: "Lorem ipsum dolor sit amet consectetur. Id leo faucibus at quis. Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin.Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin."
        },
        {
            label: "PAGO",
            title: "PAGO",
            description: "Lorem ipsum dolor sit amet consectetur. Id leo faucibus at quis. Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin.Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin."
        },
        {
            label: "ENTREGA",
            title: "ENTREGA",
            description: "Lorem ipsum dolor sit amet consectetur. Id leo faucibus at quis. Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin.Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin."
        },
        {
            label: "SERVICIOS PARA ELÉCTRICOS",
            title: "SERVICIOS PARA ELÉCTRICOS",
            description: "Lorem ipsum dolor sit amet consectetur. Id leo faucibus at quis. Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin.Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin."
        },
        {
            label: "DERECHO DE DESESTIMIENTO",
            title: "DERECHO DE DESESTIMIENTO",
            description: "Lorem ipsum dolor sit amet consectetur. Id leo faucibus at quis. Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin.Purus tristique orci dignissim in. Gravida ut placerat massa massa at sit eu nisi tristique. Nibh ut vitae sit amet at pulvinar consequat platea proin."
        }
    ];

    const characteristics = [
        {
            label: `100% Online`,
            icon: images.characteristics1
        },
        {
            label: `Compra segura y protegida`,
            icon: images.characteristics3
        },
        {
            label: `Obtén financiamiento`,
            icon: images.characteristics2
        },
        {
            label: `Opción de despacho gratis\n a tu domicilio`,
            icon: images.characteristics4
        }
    ];

    const conditionsOptions = [
        {
            label: "CONDICIONES GENERALES DE VENTA",
            redirect: "/terms"
        },
        {
            label: "CONDICIONES GENERALES DE USO",
            redirect: "/terms"
        },
        {
            label: "POLÍTICA DE PRIVACIDAD",
            redirect: "/terms"
        },
        {
            label: "CONFIGURACIÓN DE COOKIES",
            redirect: "/terms"
        }
    ];

    const scrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
    };

    return(
        <footer className={styles.footer}>
            <h2>PÍDELO ONLINE</h2>
            <div className={styles.charOptions}>
                {
                    characteristics.map((char) => (
                        <div className={styles.charOption}>
                            <img src={char.icon} />
                            <p>{char.label}</p>
                        </div>
                    ))
                }
            </div>
            <div className={styles.lastSeparator}/>
            <div className={styles.lastOptions}>
                <button onClick={scrollToTop} className={styles.arrowUpButton}>
                    <img src={images.arrowUp} />
                </button>
                <img src={images.citroenFooter} />
                <span>Powered by <img src={images.byLinze}/></span>
                <div className={styles.conditionsOptions}>
                    {conditionsOptions.map((conditionOpt, index) => (
                        <a href={conditionOpt.redirect}>{conditionOpt.label} {index < 3 ? <span className={styles.separator}/> : null}</a>
                    ))}
                </div>
            </div>
        </footer>
    )
};

export default Footer;